import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"

export const useLinkStore = () => {
	const authenticatedFetch = useAuthenticatedFetch()

	return async ({
		userId,
		store,
		accessToken,
		isEmbeddedAppAccessToken = false,
		activeSubscriptionId = null,
	}) => {
		return await authenticatedFetch("/api/firestore/linkStore", {
			method: "POST",
			body: JSON.stringify({
				userId,
				store,
				accessToken,
				isEmbeddedAppAccessToken,
				activeSubscriptionId,
			}),
		})
			.then((res) => res.json())
			.then((json) => {
				return {
					success: json?.success || false,
					userCheckedScopes: json?.userCheckedScopes || [],
					requiredScopes: json?.requiredScopes || [],
					errorCode: json?.errorCode || null,
				}
			})
			.catch((err) => {
				console.error(err)
				return {
					success: false,
					userCheckedScopes: [],
					requiredScopes: [],
					errorCode: null,
				}
			})
	}
}

export const useUpdateAccessToken = () => {
	const authenticatedFetch = useAuthenticatedFetch()

	return async (userId, store, accessToken) => {
		return await authenticatedFetch("/api/firestore/updateAccessToken", {
			method: "POST",
			body: JSON.stringify({
				userId,
				store,
				accessToken,
			}),
		})
			.then((res) => res.json())
			.then((json) => {
				return {
					success: json?.success || false,
					userCheckedScopes: json?.userCheckedScopes || [],
					requiredScopes: json?.requiredScopes || [],
					errorCode: json?.errorCode || null,
				}
			})
			.catch((err) => {
				console.error(err)
				return {
					success: false,
					userCheckedScopes: [],
					requiredScopes: [],
					errorCode: null,
				}
			})
	}
}

export const useLinkEmbeddedStoreHandoff = () => {
	const authenticatedFetch = useAuthenticatedFetch()

	return async ({ userId, store, activeSubscriptionId = null }) => {
		return await authenticatedFetch(
			"/api/firestore/linkEmbeddedStoreHandoff",
			{
				method: "POST",
				body: JSON.stringify({
					userId,
					store,
					activeSubscriptionId,
				}),
			},
		)
			.then((res) => res.json())
			.then((json) => {
				return {
					success: json?.success || false,
					userCheckedScopes: json?.userCheckedScopes || [],
					requiredScopes: json?.requiredScopes || [],
					errorCode: json?.errorCode || null,
				}
			})
			.catch((err) => {
				console.error(err)
				return {
					success: false,
					userCheckedScopes: [],
					requiredScopes: [],
					errorCode: null,
				}
			})
	}
}
